export default {
    customerId: {
        presence: true,
        type: "string",
    },
};
